import { useState } from "react";
import { usd } from "./util";
import { composicion, pctTxt } from "./graf";

const R = 70, C = 2 * Math.PI * R;

export const Dona = ({ d }) => {
  const [sel, setSel] = useState(null);
  const tramos = composicion(d.vencimientos), total = tramos.reduce((a, t) => a + t.monto, 0);
  let acum = 0;
  const activo = tramos.find((t) => t.id === sel);
  return (
    <section className="rs-panel der rg-sec" data-testid="resumen-panel-composicion">
      <h3>Composición del saldo</h3>
      {!total ? <p className="rs-vacio">Sin deuda abierta.</p> : (
        <div className="rg-dona-wrap">
          <svg viewBox="0 0 180 180" className="rg-dona" role="img" aria-label="Composición del saldo">
            {tramos.filter((t) => t.monto > 0).map((t, i) => {
              const largo = (t.monto / total) * C, off = acum; acum += largo;
              return <circle key={t.id} cx="90" cy="90" r={R} fill="none" stroke={t.c} strokeWidth={sel === t.id ? 24 : 16} strokeDasharray={`${largo} ${C}`} strokeDashoffset={-off}
                className="rg-arco" style={{ animationDelay: `${i * 160}ms`, "--largo": largo, "--c": C }} transform="rotate(-90 90 90)" tabIndex={0}
                onMouseEnter={() => setSel(t.id)} onMouseLeave={() => setSel(null)} onFocus={() => setSel(t.id)} onBlur={() => setSel(null)} onClick={() => setSel(sel === t.id ? null : t.id)} data-testid={`resumen-dona-${t.id}`} />;
            })}
            <text x="90" y="86" textAnchor="middle" fill="#EEF3EC" fontSize="17" fontWeight="800" data-testid="resumen-dona-centro">{usd(activo ? activo.monto : total)}</text>
            <text x="90" y="104" textAnchor="middle" fill="#A9B8A5" fontSize="10" fontWeight="700">{(activo ? activo.n : "saldo total").toUpperCase()}</text>
          </svg>
          <ul className="rg-leyenda">
            {tramos.map((t) => (
              <li key={t.id} className={sel === t.id ? "on" : ""} onMouseEnter={() => setSel(t.id)} onMouseLeave={() => setSel(null)} style={{ opacity: t.monto ? 1 : .45 }}>
                <i style={{ background: t.c }} /><span>{t.n}</span><b>{t.monto ? pctTxt(t.monto, total) : "0%"}</b>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};
